module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "boxp"
  }, [_vm._v("Front cover. Top: Front three-quarter view of the Amalgam Collection E-Type Roadster 1/8 scale. Centre photos clockwise from top left: E-Type V12 S3 Coupe with longer wheelbase defined a different E-Type for the 1970s; The essential S1 soft-top E-Type in all its ellipsoid elegance; The S1 fastback Coupe and S2 Roadster show off their different designs. Profile: E-Type Roadster in red (David Bocquelet).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-028a4eb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Fm02.vue
// module id = 66
// module chunks = 0